import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://fastapi-backend-657266059621.asia-northeast1.run.app/api';

// 모든 이벤트 가져오기
export const fetchAllEvents = createAsyncThunk('events/fetchAllEvents', async () => {
  const response = await axios.get(`${BASE_URL}/events/`);
  return response.data;
});

// 좋아하는 이벤트 목록 가져오기
export const fetchLikedEvents = createAsyncThunk('events/fetchLikedEvents', async (userId) => {
  const response = await axios.get(`${BASE_URL}/users/${userId}/liked-events`);
  return response.data.likedEvents || [];
});

// 이벤트 좋아요 토글
export const toggleLikeEvent = createAsyncThunk(
  'events/toggleLikeEvent',
  async ({ userId, eventId, isLiked }, { rejectWithValue }) => {
    try {
      const method = isLiked ? 'DELETE' : 'POST';
      await axios({
        url: `${BASE_URL}/users/${userId}/like-event/${eventId}`,
        method,
        headers: { 'Content-Type': 'application/json' },
      });
      return eventId; // Return the updated event ID
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to toggle like');
    }
  }
);

// Initial State
const initialState = {
  allEvents: [],
  likedEvents: [],
  isLoading: false,
  error: null,
};

// Slice
const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllEvents.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allEvents = action.payload;
      })
      .addCase(fetchAllEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchLikedEvents.fulfilled, (state, action) => {
        state.likedEvents = action.payload;
      })
      .addCase(toggleLikeEvent.fulfilled, (state, action) => {
        const eventId = action.payload;
        if (state.likedEvents.includes(eventId)) {
          state.likedEvents = state.likedEvents.filter((id) => id !== eventId);
        } else {
          state.likedEvents.push(eventId);
        }
      });
  },
});

export default eventsSlice.reducer; 